import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from 'lib/utils';

interface UnlockButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Spinner while the unlock request is in flight. */
  loading?: boolean;
  size?: 'md' | 'lg';
}

/**
 * The one upgrade call to action on a locked result: a violet-to-pink gradient, never the brand lime,
 * so it reads as "paid" next to the lime primary buttons.
 */
export function UnlockButton({ loading = false, size = 'md', className, children, disabled, ...props }: UnlockButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled || loading}
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-xl bg-[linear-gradient(105deg,#4F2BE0,#A21CAF_55%,#DB2777)] font-bold text-white',
        'shadow-[0_14px_28px_-14px_rgba(162,28,175,0.7),inset_0_1px_0_rgba(255,255,255,0.28)] transition-[filter,transform]',
        'hover:-translate-y-px hover:brightness-110 focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-foreground',
        'disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:translate-y-0 disabled:hover:brightness-100 motion-reduce:transition-none motion-reduce:hover:translate-y-0',
        size === 'lg' ? 'px-7 py-4 text-[15.5px]' : 'px-4 py-2.5 text-[13.5px]',
        className,
      )}
      {...props}
    >
      {loading && <Loader2 className="h-4 w-4 animate-spin" aria-hidden />}
      {children}
    </button>
  );
}
